import { getHcProp } from "../internal/get-hc-prop.js";
import { getButtonProps } from "./shared.js";
import button_module_default from "./button.module.js";
import { Button } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/button/Button.tsx
const getBorderRadius = (size) => {
	if (size === "sm" || size === "xs") return "var(--mantine-radius-xxs)";
	return "var(--mantine-radius-xs)";
};
const Button$1 = ({ children, color = "primary", size = "md", LeftIcon, RightIcon, "data-testid": testId, ...restProps }) => {
	const btnProps = getButtonProps(restProps);
	const hcProp = getHcProp(color);
	return /* @__PURE__ */ jsx(Button, {
		...btnProps,
		...hcProp,
		classNames: button_module_default,
		color,
		size,
		rightSection: RightIcon && /* @__PURE__ */ jsx(RightIcon, { color: "currentColor" }),
		leftSection: LeftIcon && /* @__PURE__ */ jsx(LeftIcon, { color: "currentColor" }),
		__vars: { "--button-radius": getBorderRadius(size) },
		"data-testid": testId,
		children
	});
};

//#endregion
export { Button$1 as Button };